import { languageMap } from ".."

languageMap.xojo = {
	comments: {
		line: "//",
	},
}
